<script lang="ts" setup>
import './style.scss';
import AppFooter from '@ui/widgets/App/Footer/index.vue';
import { CompanyNewHeader } from '@entities/company';

const className = 'empty';
</script>

<template>
  <div :class="className">
    <CompanyNewHeader />
    <main :class="`${className}-content`">
      <div :class="`${className}-page`">
        <slot />
      </div>
    </main>
    <AppFooter />
  </div>
</template>
